var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Files-Folders / File / Grey Filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Files-Folders-/-File-/-Grey-Filled",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "common-file-double",
    transform: "translate(4.000000, 2.000000)",
    fill: "#999999",
    stroke: "#999999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.375,18.159 C16.3979491,19.149787 15.6156777,19.9727365 14.625,20 L2.375,20 C1.38432232,19.9727365 0.602050945,19.149787 0.625,18.159 L0.625,2.591 C0.602050945,1.60021299 1.38432232,0.777263501 2.375,0.75 L11.275,0.75 C11.7441075,0.752355265 12.1916728,0.94721606 12.513,1.289 L15.862,4.813 C16.1929928,5.1647606 16.3765833,5.62999976 16.375,6.113 L16.375,18.159 Z",
    id: "Shape",
    strokeWidth: 1.5,
    fillOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    points: "15.8 5.8 12 2 12 5.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileGrey);
export default __webpack_public_path__ + "static/media/file-grey.f59eeded877c941fe9689526090cf059.svg";
export { ForwardRef as ReactComponent };